import { render } from "./Transfers.vue?vue&type=template&id=3e3e4700&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"

import "./Transfers.vue?vue&type=style&index=0&id=3e3e4700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3e4700"]])

export default __exports__